export const policy = `
<p style="text-align: center">
<span style="font-size: 10.5pt"
  ><span style="font-family: 等线"
    ><strong
      ><span style="font-size: 24pt"
        ><span style="font-family: 'Times New Roman', serif"
          ><span style="color: #505050">PRIVACY POLICY</span></span
        ></span
      ></strong
    ></span
  ></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 12pt"
  ><span style="font-family: 宋体"
    ><span style="font-family: 'Times New Roman', serif"
      ><span style="color: #505050"
        >HANGZHOU HIKVISION DIGITAL TECHNOLOGY CO. LTD and its affiliates
        (&ldquo;HIKVISION&rdquo;, &ldquo;we&rdquo;, &ldquo;ours&rdquo; or
        &ldquo;us&rdquo;) take your personal information very seriously.
        This Privacy Policy (&ldquo;Policy&rdquo;) explains how HIKVISION
        processes your personal information collected through this
        questionnaire investigation (&ldquo;Survey&rdquo;). Please review
        this Policy before filling and submitting the Survey.&nbsp;</span
      ></span
    ></span
  ></span
>
</p>

<ol start="1">

<li>
  <span style="font-size: 12pt"
    ><span style="font-family: 宋体"
      ><strong
        ><span style="font-family: 'Times New Roman', serif"
          ><span style="color: #505050"
            >1. The Purpose of Collecting Your Personal Information</span
          ></span
        ></strong
      ></span
    ></span
  >
</li>

</ol>

<p style="text-align: justify">
<span style="font-size: 12pt"
  ><span style="font-family: 宋体"
    ><span style="font-family: 'Times New Roman', serif"
      ><span style="color: #505050"
        >In order to improve customer experience and provide more targeted
        and dedicated services, HIKVISION invites you to participate in
        this Survey. Through your submission of the Survey, HIKVISION
        would collect, store, use and share your personal information such
        as your name, email address, your company, your country or region,
        etc. &nbsp;</span
      ></span
    ></span
  ></span
>
</p>

<ol start="2">

<li>
  <span style="font-size: 12pt"
    ><span style="font-family: 宋体"
      ><strong
        ><span style="font-family: 'Times New Roman', serif"
          ><span style="color: #505050"
            >2. Use of Your Personal Information</span
          ></span
        ></strong
      ></span
    ></span
  >
</li>

</ol>

<p>
<span style="font-size: 12pt"
  ><span style="font-family: 宋体"
    ><span style="font-family: 'Times New Roman', serif"
      ><span style="color: #505050"
        >HIKVISION will use your personal information for the following
        purposes:</span
      ></span
    ></span
  ></span
>
</p>

<ul>

<li>
  <span style="font-size: 12pt"
    ><span style="font-family: 宋体"
      ><em
        ><span style="font-family: 'Times New Roman', serif"
          ><span style="color: #505050"
            >Events Registration and Participation
          </span></span
        ></em
      ></span
    ></span
  >
</li>

</ul>

<p style="text-align: justify">
<span style="font-size: 12pt"
  ><span style="font-family: 宋体"
    ><span style="font-family: 'Times New Roman', serif"
      ><span style="color: #505050"
        >For events registration purpose, HIKVISION may collect your name,
        contact information including phone number and email address, the
        country or region where the company or organization you serve for
        is located, information regarding your work, including the company
        or organization you serve for and its address, your
        position/title.</span
      ></span
    ></span
  ></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 12pt"
  ><span style="font-family: 宋体"
    ><span style="font-family: 'Times New Roman', serif"
      ><span style="color: #505050"
        >For letting you have better events experiences, HIKVISION may
        collect your preference to the events participation, including the
        date and location that you would like to participate the events,
        whether you need airport pickup service and accommodation to be
        arranged by HIKVISION.&nbsp;
      </span></span
    ></span
  ></span
>
</p>

<ul>

<li>
  <span style="font-size: 12pt"
    ><span style="font-family: 宋体"
      ><em
        ><span style="font-family: 'Times New Roman', serif"
          ><span style="color: #505050"
            >Registration Confirmation
          </span></span
        ></em
      ></span
    ></span
  >
</li>

</ul>

<p style="text-align: justify">
<span style="font-size: 12pt"
  ><span style="font-family: 宋体"
    ><span style="font-family: 'Times New Roman', serif"
      ><span style="color: #505050"
        >To verify your eligibility for events, HIKVISION may collect some
        business information, including the annual purchase amount from
        HIKVISION of your company or organization, products that purchased
        by your company or organization, whether the company or
        organization is a signed partner of HIKVISION.</span
      ></span
    ></span
  ></span
>
</p>

<ul>

<li style="text-align: justify">
  <span style="font-size: 12pt"
    ><span style="font-family: 宋体"
      ><em
        ><span style="font-family: 'Times New Roman', serif"
          ><span style="color: #505050"
            >Travelling and Accommodation Booking</span
          ></span
        ></em
      ></span
    ></span
  >
</li>

</ul>

<p style="text-align: justify">
<span style="font-size: 12pt"
  ><span style="font-family: 宋体"
    ><span style="font-family: 'Times New Roman', serif"
      ><span style="color: #505050"
        >For events which we may provide travelling and accommodation,
        HIKVISION may collect your identification information, such as the
        validity and number of your passports to help book tickets and
        accommodations.&nbsp;
      </span></span
    ></span
  ></span
>
</p>

<ul>

<li>
  <span style="font-size: 12pt"
    ><span style="font-family: 宋体"
      ><em
        ><span style="font-family: 'Times New Roman', serif"
          ><span style="color: #505050">Flight Information</span></span
        ></em
      ></span
    ></span
  >
</li>

</ul>

<p style="text-align: justify">
<span style="font-size: 12pt"
  ><span style="font-family: 宋体"
    ><span style="font-family: 'Times New Roman', serif"
      ><span style="color: #505050"
        >To provide pick up service for you, HIKVISION may collect your
        flight information such as the flight number, arrival date and
        time, destination airport.
      </span></span
    ></span
  ></span
>
</p>

<ul>

<li>
  <span style="font-size: 12pt"
    ><span style="font-family: 宋体"
      ><em
        ><span style="font-family: 'Times New Roman', serif"
          ><span style="color: #505050">Feedbacks</span></span
        ></em
      ></span
    ></span
  >
</li>

</ul>

<p style="text-align: justify">
<span style="font-size: 12pt"
  ><span style="font-family: 宋体"
    ><span style="font-family: 'Times New Roman', serif"
      ><span style="color: #505050"
        >For improving all services provided by HIKVISION, HIKVISION may
        collect your feedbacks towards our events, lecturers and
        products.</span
      ></span
    ></span
  ></span
>
</p>

<ol start="3">

<li>
  <span style="font-size: 12pt"
    ><span style="font-family: 宋体"
      ><span style="font-family: 'Times New Roman', serif"
        ><span style="color: #505050"
          >&nbsp;<strong
            >3. Sharing of Your Personal Information</strong
          ></span
        ></span
      ></span
    ></span
  >
</li>

</ol>

<p style="text-align: justify">
<span style="font-size: 12pt"
  ><span style="font-family: 宋体"
    ><span style="font-family: 'Times New Roman', serif"
      ><span style="color: #505050"
        >We do not sell any personal information to third parties and we
        never will.</span
      ></span
    ></span
  ></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 12pt"
  ><span style="font-family: 宋体"
    ><span style="font-family: 'Times New Roman', serif"
      ><span style="color: #505050"
        >HIKVISION will not disclose your personal information, unless (1)
        with your prior written consent; (2) in accordance with the
        applicable laws and regulations, or where required by competent
        authorities; (3) to protect its legitimate interests, for example,
        to defend its rights on administrative or judicial procedures or
        in case its business or parts thereof is transferred to sold to
        another party.&nbsp;</span
      ></span
    ></span
  ></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 12pt"
  ><span style="font-family: 宋体"
    ><span style="font-family: 'Times New Roman', serif"
      ><span style="color: #505050"
        >HIKVISION limits access to your personal information on a
        need-to-know basis, and requires its employees to respect the
        confidentiality of your information and protect your information
        in accordance with the Policy.&nbsp;</span
      ></span
    ></span
  ></span
>
</p>

<ol start="4">

<li>
  <span style="font-size: 12pt"
    ><span style="font-family: 宋体"
      ><strong
        ><span style="font-family: 'Times New Roman', serif"
          ><span style="color: #505050"
            >4. Storage and Security of Your Personal Information</span
          ></span
        ></strong
      ></span
    ></span
  >
</li>

</ol>

<p style="text-align: justify">
<span style="font-size: 12pt"
  ><span style="font-family: 宋体"
    ><span style="font-family: 'Times New Roman', serif"
      ><span style="color: #505050"
        >HIKVISION stores your personal information in the data base
        located in Singapore and &nbsp;&nbsp;for no longer than is
        necessary for the purposes stated in this Policy, unless otherwise
        requested by user or permitted by law.&nbsp;</span
      ></span
    ></span
  ></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 12pt"
  ><span style="font-family: 宋体"
    ><span style="font-family: 'Times New Roman', serif"
      ><span style="color: #505050"
        >We have implemented commercially reasonable administrative,
        technical, and physical security controls that are designed to
        safeguard personal information. We also conduct periodic reviews
        and assessments of the effectiveness of our security
        controls.</span
      ></span
    ></span
  ></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 12pt"
  ><span style="font-family: 宋体"
    ><span style="font-family: 'Times New Roman', serif"
      ><span style="color: #505050"
        >Notwithstanding the above, no method of transmission over the
        Internet, or method of electronic storage, is 100% secure.
        Therefore, HIKVISION cannot guarantee that your personal
        information is under absolute security with the existing security
        technology.&nbsp;</span
      ></span
    ></span
  ></span
>
</p>

<ol start="5">

<li>
  <span style="font-size: 12pt"
    ><span style="font-family: 宋体"
      ><strong
        ><span style="font-family: 'Times New Roman', serif"
          ><span style="color: #505050"
            >5. Transfer of Personal Information outside of Your
            Jurisdiction</span
          ></span
        ></strong
      ></span
    ></span
  >
</li>

</ol>

<p style="text-align: justify">
<span style="font-size: 12pt"
  ><span style="font-family: 宋体"
    ><span style="font-family: 'Times New Roman', serif"
      ><span style="color: #505050"
        >HANGZHOU HIKVISION DIGITAL TECHNOLOGY CO. LTD is a
        China-headquartered company operating globally. As such, complying
        with applicable laws, we may transfer your personal data to any
        subsidiary of the HIKVISION group worldwide when processing that
        information for the purposes described in this Privacy Policy.
      </span></span
    ></span
  ></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 12pt"
  ><span style="font-family: 宋体"
    ><span style="font-family: 'Times New Roman', serif"
      ><span style="color: #505050"
        >You have understood that the risks under applicable data
        protection laws are different and we may transfer to and store
        your personal information at our overseas facilities. However,
        this does not change any of our commitments to safeguard your
        personal information in accordance with this Policy.</span
      ></span
    ></span
  ></span
>
</p>

<ol start="6">

<li>
  <span style="font-size: 12pt"
    ><span style="font-family: 宋体"
      ><span style="font-family: 'Times New Roman', serif"
        ><span style="color: #505050"
          >&nbsp;<strong>6. Your rights</strong>&nbsp;</span
        ></span
      ></span
    ></span
  >
</li>

</ol>

<p style="text-align: justify">
<span style="font-size: 12pt"
  ><span style="font-family: 宋体"
    ><span style="font-family: 'Times New Roman', serif"
      ><span style="color: #505050"
        >Depending on where you are located and subject to limitations in
        applicable law, you have certain rights in respect to your
        personal information, such as a right of access, rectification,
        restriction, opposition, and portability. In order to exercise
        your rights please contact us at the contact information below.
        You also have the right to withdraw your consent at all times,
        free of charge.
      </span></span
    ><span style="font-size: 10.5pt"
      ><span style="font-family: 等线"
        ><a
          class="msocomanchor"
          href="#_msocom_1"
          id="_anchor_1"
          name="_msoanchor_1"
          style="color: #007bff; text-decoration: none"
          ><span style="font-family: 等线"></span></a
        >&nbsp;</span
      ></span
    ></span
  ></span
>
</p>

<ol start="7">

<li>
  <span style="font-size: 12pt"
    ><span style="font-family: 宋体"
      ><strong
        ><span style="font-family: 'Times New Roman', serif"
          ><span style="color: #505050">7. Children Policy</span></span
        ></strong
      ></span
    ></span
  >
</li>

</ol>

<p style="text-align: justify">
<span style="font-size: 12pt"
  ><span style="font-family: 宋体"
    ><span style="font-family: 'Times New Roman', serif"
      ><span style="color: #505050"
        >This Survey is designed and intended for adults. HIKVISION does
        not intend that any portion of Survey will be accessed or used by
        children under the age of 18, or equivalent minimum age in the
        relevant jurisdiction and such use is prohibited.
      </span></span
    ></span
  ></span
>
</p>

<ol start="8">

<li>
  <span style="font-size: 12pt"
    ><span style="font-family: 宋体"
      ><strong
        ><span style="font-family: 'Times New Roman', serif"
          ><span style="color: #505050">8. Contact method</span></span
        ></strong
      ></span
    ></span
  >
</li>

</ol>

<p style="text-align: justify">
<span style="font-size: 12pt"
  ><span style="font-family: 宋体"
    ><span style="font-family: 'Times New Roman', serif"
      ><span style="color: #505050"
        >If you have questions or concerns about HIKVISION&rsquo;s use of
        your personal information, you can contact us at:
        Digital.Global@hikvision.com.
      </span></span
    ><span style="font-size: 10.5pt"
      ><span style="font-family: 'Times New Roman', serif"
        ><a
          class="msocomanchor"
          href="#_msocom_2"
          id="_anchor_2"
          name="_msoanchor_2"
          style="color: #007bff; text-decoration: none"
          ><span style="font-family: 等线"></span></a
        >&nbsp;</span
      ></span
    ></span
  ></span
>
</p>

<p>
<span style="font-size: 12pt"
  ><span style="font-family: 宋体"
    ><strong
      ><span style="font-family: 'Times New Roman', serif"
        ><span style="color: #505050">GDPR/UK Addendum</span></span
      ></strong
    ></span
  ></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 10.5pt"
  ><span style="font-family: 等线"
    ><span style="font-size: 12pt"
      ><span style="font-family: 'Times New Roman', serif"
        ><span style="color: #505050"
          >Whenever HIKVISION shares personal information originating in
          the EEA or UK with a third party, which may or may not be a
          HIKVISION entity, that is outside the EEA or UK, we will do so
          on the basis of standard contractual clauses or any other
          safeguards provided for in GDPR or UK data protection law.</span
        ></span
      ></span
    ></span
  ></span
>
</p>

<p style="text-align: justify">&nbsp;</p>

<p>
<span style="font-size: 12pt"
  ><span style="font-family: 宋体"
    ><strong
      ><span style="font-family: OpenSansRegular"
        ><span style="color: #505050">Brazil Addendum</span></span
      ></strong
    ></span
  ></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 10.5pt"
  ><span style="font-family: 等线"
    ><span style="font-size: 12pt"
      ><span style="font-family: 'Times New Roman', serif"
        ><span style="color: #505050"
          >Whenever Hikvision shares personal information originating in
          Brazil with a third party, which may or may not be a HIKVISION
          entity, that is outside of Brazil, we will do so on the basis of
          standard contractual clauses or any other safeguards provided
          for in the LGPD.</span
        ></span
      ></span
    ></span
  ></span
>
</p>

<p style="text-align: justify">&nbsp;</p>

<p>
<span style="font-size: 12pt"
  ><span style="font-family: 宋体"
    ><strong
      ><span style="font-family: OpenSansRegular"
        ><span style="color: #505050">South Africa Addendum</span></span
      ></strong
    ></span
  ></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 10.5pt"
  ><span style="font-family: 等线"
    ><span style="font-size: 12pt"
      ><span style="font-family: 'Times New Roman', serif"
        ><span style="color: #505050"
          >Whenever Hikvision processes personal information originating
          in South Africa and transfers such information outside of South
          Africa, we will do so on the basis of any safeguards provided
          for and standard contractual clauses stipulated in the
          POPIA.</span
        ></span
      ></span
    ></span
  ></span
>
</p>

<p style="text-align: justify">&nbsp;</p>

<p>
<span style="font-size: 12pt"
  ><span style="font-family: 宋体"
    ><strong
      ><span style="font-family: 'Times New Roman', serif"
        ><span style="color: #505050"
          >California Consumer Privacy Act Notice</span
        ></span
      ></strong
    ></span
  ></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 12pt"
  ><span style="font-family: 宋体"
    ><span style="font-family: 'Times New Roman', serif"
      ><span style="color: #505050">Please refer to ANNEX A.</span></span
    ></span
  ></span
>
</p>

<p>&nbsp;</p>

<p style="text-align: left">&nbsp;</p>

<p style="text-align: center">
<span style="font-size: 12pt"
  ><span style="font-family: 宋体"
    ><strong
      ><span style="font-size: 10.5pt"
        ><span style="font-family: 'Times New Roman', serif"
          ><span style="color: #505050">ANNEX A</span></span
        ></span
      ></strong
    ></span
  ></span
>
</p>

<p style="text-align: center">
<span style="font-size: 12pt"
  ><span style="font-family: 宋体"
    ><strong
      ><span style="font-size: 10.5pt"
        ><span style="font-family: 'Times New Roman', serif"
          ><span style="color: #505050"
            >Additional State-Specific Privacy Disclosures</span
          ></span
        ></span
      ></strong
    ></span
  ></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 10.5pt"
  ><span style="font-family: 等线"
    ><span style="font-size: 12pt"
      ><span style="font-family: 'Times New Roman', serif"
        ><span style="color: #505050"
          >This Additional State-Specific Privacy Disclosure
          (&ldquo;Disclosure&rdquo;) provides additional information to
          California, Virginia, Colorado, Connecticut, or Utah residents
          whose personal information is processed by Hangzhou Hikvision
          Digital Technology Co. Ltd. and its U.S. subsidiary
          (collectively, &ldquo;HIKVISION&rdquo;) pursuant to the
          California Consumer Privacy Act of 2018, as amended by the
          California Privacy Rights Act of 2020 (collectively,
          &ldquo;CCPA&rdquo;), the Virginia Consumer Data Protection Act
          (&ldquo;VCDPA&rdquo;), the Colorado Privacy Act
          (&ldquo;CPA&rdquo;), the Connecticut Data Privacy Act
          (&ldquo;CDPA&rdquo;), and the Utah Consumer Privacy Act
          (&ldquo;UCPA&rdquo;). Any terms defined in the CCPA, VCDPA, CPA,
          CDPA, and UCPA have the same meaning when used in this
          Disclosure.</span
        ></span
      ></span
    ></span
  ></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 10.5pt"
  ><span style="font-family: 等线">&nbsp;</span></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 10.5pt"
  ><span style="font-family: 等线"
    ><span style="font-size: 12pt"
      ><span style="font-family: 'Times New Roman', serif"
        ><span style="color: #505050"
          >If you are not a California, Virginia, Colorado, Connecticut,
          or Utah resident, this Disclosure does not apply to you. This
          Disclosure supplements the&nbsp;</span
        ></span
      ></span
    ><a
      href="https://www.hikvision.com/us-en/policies/privacy-policy/"
      style="color: #007bff; text-decoration: none"
      target="_blank"
      ><span style="font-size: 12pt"
        ><span style="font-family: 'Times New Roman', serif"
          ><span style="color: #505050">Privacy Policy</span></span
        ></span
      ></a
    ><span style="font-size: 12pt"
      ><span style="font-family: 'Times New Roman', serif"
        ><span style="color: #505050"
          >&nbsp;and is applicable to HIKVISION websites, products, and
          services that display or provide links to it.</span
        ></span
      ></span
    ></span
  ></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 10.5pt"
  ><span style="font-family: 等线">&nbsp;</span></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 10.5pt"
  ><span style="font-family: 等线"
    ><span style="font-size: 12pt"
      ><span style="font-family: 'Times New Roman', serif"
        ><span style="color: #505050"
          >Categories of Personal Information Collected and
          Disclosed</span
        ></span
      ></span
    ></span
  ></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 10.5pt"
  ><span style="font-family: 等线">&nbsp;</span></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 10.5pt"
  ><span style="font-family: 等线"
    ><span style="font-size: 12pt"
      ><span style="font-family: 'Times New Roman', serif"
        ><span style="color: #505050"
          >During the preceding 12 months, HIKVISION has collected the
          following categories of personal information that are processed
          pursuant to the CCPA, VCDPA, CPA, CDPA and UCPA:</span
        ></span
      ></span
    ></span
  ></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 10.5pt"
  ><span style="font-family: 等线">&nbsp;</span></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 10.5pt"
  ><span style="font-family: 等线"
    ><u
      ><span style="font-size: 12pt"
        ><span style="font-family: 'Times New Roman', serif"
          ><span style="color: #505050"
            >Categories of Personal Information</span
          ></span
        ></span
      ></u
    ><span style="font-size: 12pt"
      ><span style="font-family: 'Times New Roman', serif"
        ><span style="color: #505050">:</span></span
      ></span
    ></span
  ></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 10.5pt"
  ><span style="font-family: 等线">&nbsp;</span></span
>
</p>

<ol>

<li style="text-align: justify;padding-left: 12px">
  <span style="font-size: 10.5pt"
    ><span style="color: #505050"
      ><span style="font-family: 等线"
        ><span style="font-size: 12pt"
          ><span style="font-family: 'Times New Roman', serif"
            >1. Identifiers, such as your name, the validity and number of
            your passports, contact information including your email
            address or phone number, the country or region where the
            company or organization you serve for is located;</span
          ></span
        ></span
      ></span
    ></span
  >
</li>

<li style="text-align: justify;padding-left: 12px"">
  <span style="font-size: 10.5pt"
    ><span style="color: #505050"
      ><span style="font-family: 等线"
        ><span style="font-size: 12pt"
          ><span style="font-family: 'Times New Roman', serif"
            >2. Professional or employment-related information, such as your
            position/title and the location of the company or organization
            you serve for;</span
          ></span
        ></span
      ></span
    ></span
  >
</li>

<li style="text-align: justify;padding-left: 12px"">
  <span style="font-size: 10.5pt"
    ><span style="color: #505050"
      ><span style="font-family: 等线"
        ><span style="font-size: 12pt"
          ><span style="font-family: 'Times New Roman', serif"
            >3. Flight information, including flight number, arrival date and
            time, and destination airport;</span
          ></span
        ></span
      ></span
    ></span
  >
</li>

<li style="text-align: justify;padding-left: 12px"">
  <span style="font-size: 10.5pt"
    ><span style="color: #505050"
      ><span style="font-family: 等线"
        ><span style="font-size: 12pt"
          ><span style="font-family: 'Times New Roman', serif"
            >4. Business information, including the annual purchase amount
            from HIKVISION of your company or organization, products that
            purchased by your company or organization, whether the company
            or organization is a signed partner of HIKVISION;</span
          ></span
        ></span
      ></span
    ></span
  >
</li>

<li style="text-align: justify;padding-left: 12px"">
  <span style="font-size: 10.5pt"
    ><span style="color: #505050"
      ><span style="font-family: 等线"
        ><span style="font-size: 12pt"
          ><span style="font-family: 'Times New Roman', serif"
            >5. Inferences data, such as information about your satisfaction
            to our events, products and services;</span
          ></span
        ></span
      ></span
    ></span
  >
</li>

<li style="text-align: justify;padding-left: 12px"">
  <span style="font-size: 10.5pt"
    ><span style="color: #505050"
      ><span style="font-family: 等线"
        ><span style="font-size: 12pt"
          ><span style="font-family: 'Times New Roman', serif"
            >6. Other information as described above that may be considered
            personal information under the CCPA, VCDPA, CPA, CDPA and
            UCPA.</span
          ></span
        ></span
      ></span
    ></span
  >
</li>

</ol>

<p style="text-align: justify">
<span style="font-size: 10.5pt"
  ><span style="font-family: 等线">&nbsp;</span></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 10.5pt"
  ><span style="font-family: 等线"
    ><span style="font-size: 12pt"
      ><span style="font-family: 'Times New Roman', serif"
        ><span style="color: #505050"
          >Sensitive information we collect</span
        ></span
      ></span
    ><span style="font-size: 12pt"
      ><span style="font-family: 宋体"
        ><span style="color: #505050">：</span></span
      ></span
    ></span
  ></span
>
</p>

<ol>

<li style="text-align: justify;padding-left: 12px"">
  <span style="font-size: 10.5pt"
    ><span style="color: #505050"
      ><span style="font-family: 等线"
        ><span style="font-size: 12pt"
          ><span style="font-family: 'Times New Roman', serif"
            >1. Identification documents, including the validity and number
            of your passports, HIKVISION may collect such information to
            provide accommodation and travelling booking for you.</span
          ></span
        ></span
      ></span
    ></span
  >
</li>

<li style="text-align: justify;padding-left: 12px"">
  <span style="font-size: 10.5pt"
    ><span style="color: #505050"
      ><span style="font-family: 等线"
        ><span style="font-size: 12pt"
          ><span style="font-family: 'Times New Roman', serif"
            >2. Flight details, including the flight number and your
            destination airport and arrival date and time, such
            information will be collected to provide airport pick-up
            service for you.</span
          ></span
        ></span
      ></span
    ></span
  >
</li>

</ol>

<p style="text-align: justify">
<span style="font-size: 10.5pt"
  ><span style="font-family: 等线"
    >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 10.5pt"
  ><span style="font-family: 等线"
    ><u
      ><span style="font-size: 12pt"
        ><span style="font-family: 'Times New Roman', serif"
          ><span style="color: #505050"
            >Sales of Personal Information:</span
          ></span
        ></span
      ></u
    ></span
  ></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 10.5pt"
  ><span style="font-family: 等线">&nbsp;</span></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 10.5pt"
  ><span style="font-family: 等线"
    ><span style="font-size: 12pt"
      ><span style="font-family: 'Times New Roman', serif"
        ><span style="color: #505050"
          >We do not and will not sell the personal information we collect
          for purposes of the CCPA, VCDPA, CPA, CDPA and UCPA.</span
        ></span
      ></span
    ></span
  ></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 10.5pt"
  ><span style="font-family: 等线">&nbsp;</span></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 10.5pt"
  ><span style="font-family: 等线"
    ><u
      ><span style="font-size: 12pt"
        ><span style="font-family: 'Times New Roman', serif"
          ><span style="color: #505050"
            >Share of Personal Information:</span
          ></span
        ></span
      ></u
    ></span
  ></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 10.5pt"
  ><span style="font-family: 等线">&nbsp;</span></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 10.5pt"
  ><span style="font-family: 等线"
    ><span style="font-size: 12pt"
      ><span style="font-family: 'Times New Roman', serif"
        ><span style="color: #505050"
          >We do not share your personal information for cross-context
          behavioral advertising, as that term is defined by the CCPA, or
          targeted advertising, as that term is defined under the VCDPA,
          CPA, CDPA and UCPA.</span
        ></span
      ></span
    ></span
  ></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 10.5pt"
  ><span style="font-family: 等线">&nbsp;</span></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 10.5pt"
  ><span style="font-family: 等线"
    ><u
      ><span style="font-size: 12pt"
        ><span style="font-family: 'Times New Roman', serif"
          ><span style="color: #505050"
            >Disclosure of Personal Information:</span
          ></span
        ></span
      ></u
    ></span
  ></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 10.5pt"
  ><span style="font-family: 等线">&nbsp;</span></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 10.5pt"
  ><span style="font-family: 等线"
    ><span style="font-size: 12pt"
      ><span style="font-family: 'Times New Roman', serif"
        ><span style="color: #505050"
          >We only disclose personal information to third parties who are
          bound by contractual obligation to use it only for the specified
          business/commercial purposes for which we disclose it to them,
          to comply with obligations under applicable state privacy laws,
          and to provide same level of privacy protection on the personal
          information. During the preceding 12 months, we have not
          disclosed each of the above-listed categories of personal
          information for such business/commercial purposes. In addition,
          your information may be accessible to third parties with whom
          you interact or direct us to share your information through our
          services.</span
        ></span
      ></span
    ></span
  ></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 10.5pt"
  ><span style="font-family: 等线">&nbsp;</span></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 10.5pt"
  ><span style="font-family: 等线"
    ><span style="font-size: 12pt"
      ><span style="font-family: 'Times New Roman', serif"
        ><span style="color: #505050"
          >HIKVISION stores your personal information for as long as
          necessarily required to provide the services, verify your
          identity, respond to your requests or questions, or fulfill the
          purposes stated in the&nbsp;</span
        ></span
      ></span
    ><a
      href="https://www.hikvision.com/us-en/policies/privacy-policy/"
      style="color: #007bff; text-decoration: none"
      target="_blank"
      ><span style="font-size: 12pt"
        ><span style="font-family: 'Times New Roman', serif"
          ><span style="color: #505050">Privacy Policy</span></span
        ></span
      ></a
    ><span style="font-size: 12pt"
      ><span style="font-family: 'Times New Roman', serif"
        ><span style="color: #505050"
          >, unless otherwise requested by you or permitted by law.</span
        ></span
      ></span
    ></span
  ></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 10.5pt"
  ><span style="font-family: 等线">&nbsp;</span></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 10.5pt"
  ><span style="font-family: 等线">&nbsp;</span></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 10.5pt"
  ><span style="font-family: 等线"
    ><span style="font-size: 12pt"
      ><span style="font-family: 'Times New Roman', serif"
        ><span style="color: #505050"
          >Your Data Protection Rights</span
        ></span
      ></span
    ></span
  ></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 10.5pt"
  ><span style="font-family: 等线">&nbsp;</span></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 10.5pt"
  ><span style="font-family: 等线"
    ><span style="font-size: 12pt"
      ><span style="font-family: 'Times New Roman', serif"
        ><span style="color: #505050"
          >You may have certain data protection rights under the
          applicable state privacy laws, including to:</span
        ></span
      ></span
    ></span
  ></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 10.5pt"
  ><span style="font-family: 等线">&nbsp;</span></span
>
</p>

<ul>

<li style="text-align: justify">
  <span style="font-size: 10.5pt"
    ><span style="color: #505050"
      ><span style="font-family: 等线"
        ><span style="font-size: 12pt"
          ><span style="font-family: 'Times New Roman', serif"
            >Request a business that collects your personal information to
            delete any personal information about you, subject to certain
            exceptions (&ldquo;Right to Delete&rdquo;);</span
          ></span
        ></span
      ></span
    ></span
  >
</li>

<li style="text-align: justify">
  <span style="font-size: 10.5pt"
    ><span style="color: #505050"
      ><span style="font-family: 等线"
        ><span style="font-size: 12pt"
          ><span style="font-family: 'Times New Roman', serif"
            >Request a business that collects and maintains your personal
            information to correct any inaccurate personal information
            about you (&ldquo;Right to Correct&rdquo;);</span
          ></span
        ></span
      ></span
    ></span
  >
</li>

<li style="text-align: justify">
  <span style="font-size: 10.5pt"
    ><span style="color: #505050"
      ><span style="font-family: 等线"
        ><span style="font-size: 12pt"
          ><span style="font-family: 'Times New Roman', serif"
            >Request a business who collects your personal information to
            disclose to you (1) the categories of personal information
            that is collected, sold, or shared; (2) the categories of
            sources from which the personal information is collected; (3)
            the business or commercial purpose for collecting, selling or
            sharing your personal information; and/or (4) the categories
            of third parties to whom the business shares, discloses, or
            sells your personal information (&ldquo;Right to Know and Data
            Portability&rdquo;);</span
          ></span
        ></span
      ></span
    ></span
  >
</li>

<li style="text-align: justify">
  <span style="font-size: 10.5pt"
    ><span style="color: #505050"
      ><span style="font-family: 等线"
        ><span style="font-size: 12pt"
          ><span style="font-family: 'Times New Roman', serif"
            >Direct a business that sells or shares your personal
            information to third parties not to sell, or share your
            personal information&nbsp;for cross-context behavioral
            advertising, as defined by the CCPA, or for targeted
            advertising, as defined by the VCDPA, CPA, CDPA and
            UCPA&nbsp;(&ldquo;Right to Opt-Out of Sales or Sharing or
            Right to Opt-Out of Sales or Targeted
            Advertising&rdquo;);</span
          ></span
        ></span
      ></span
    ></span
  >
</li>

<li style="text-align: justify">
  <span style="font-size: 10.5pt"
    ><span style="color: #505050"
      ><span style="font-family: 等线"
        ><span style="font-size: 12pt"
          ><span style="font-family: 'Times New Roman', serif"
            >Direct a business not to process your personal information
            for profiling, as defined under the VCDPA, CPA and CDPA
            (&ldquo;Right to Opt-Out of Profiling&rdquo;);</span
          ></span
        ></span
      ></span
    ></span
  >
</li>

</ul>

<p style="text-align: justify">
<span style="font-size: 10.5pt"
  ><span style="font-family: 等线">&nbsp;</span></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 10.5pt"
  ><span style="font-family: 等线"
    ><span style="font-size: 12pt"
      ><span style="font-family: 'Times New Roman', serif"
        ><span style="color: #505050"
          >To exercise your data rights, please submit your request by any
          one of the following methods:</span
        ></span
      ></span
    ></span
  ></span
>
</p>

<ul>

<li style="text-align: justify">
  <span style="font-size: 10.5pt"
    ><span style="color: #505050"
      ><span style="font-family: 等线"
        ><span style="font-size: 12pt"
          ><span style="font-family: 'Times New Roman', serif"
            >Email:&nbsp;</span
          ></span
        ><a
          href="mailto:Legal.usa@hikvision.com"
          style="color: #007bff; text-decoration: none"
          ><span style="font-size: 12pt"
            ><span style="font-family: 'Times New Roman', serif"
              >Legal.usa@hikvision.com</span
            ></span
          ></a
        ></span
      ></span
    ></span
  >
</li>

<li style="text-align: justify">
  <span style="font-size: 10.5pt"
    ><span style="color: #505050"
      ><span style="font-family: 等线"
        ><span style="font-size: 12pt"
          ><span style="font-family: 'Times New Roman', serif"
            >Toll-Free Telephone Number: 1-866- 200-6690</span
          ></span
        ></span
      ></span
    ></span
  >
</li>

<li style="text-align: justify">
  <span style="font-size: 10.5pt"
    ><span style="color: #505050"
      ><span style="font-family: 等线"
        ><span style="font-size: 12pt"
          ><span style="font-family: 'Times New Roman', serif"
            >Mailing Address: 18639 Railroad St, City of Industry, CA
            91748</span
          ></span
        ></span
      ></span
    ></span
  >
</li>

</ul>

<p style="text-align: justify">
<span style="font-size: 10.5pt"
  ><span style="font-family: 等线">&nbsp;</span></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 10.5pt"
  ><span style="font-family: 等线"
    ><span style="font-size: 12pt"
      ><span style="font-family: 'Times New Roman', serif"
        ><span style="color: #505050"
          >Once we receive your request to delete, correct, or know your
          personal information, request to opt out of sales or targeted
          advertising under the VCDPA, CPA, CDPA and UCPA, or request to
          opt out of profiling under the VCDPA, CPA and CDPA, we may
          verify it by requesting information sufficient to confirm your
          identity.&nbsp;For California resident, if you would like to use
          an authorized agent to exercise your rights, we may request
          evidence that the agent has valid written authority to submit
          requests to exercise rights on your behalf.</span
        ></span
      ></span
    ></span
  ></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 10.5pt"
  ><span style="font-family: 等线">&nbsp;</span></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 10.5pt"
  ><span style="font-family: 等线"
    ><span style="font-size: 12pt"
      ><span style="font-family: 'Times New Roman', serif"
        ><span style="color: #505050"
          >We will respond to your request within 45 days of receiving a
          verifiable request from you. Such response period may be
          extended for an additional 45 days when reasonably necessary and
          provided that a notice of the extension is provided to you
          within the first 45-day period. We reserve the right to deny
          requests in certain circumstances permitted by applicable state
          privacy laws, such as where we have a reasonable belief that the
          request is fraudulent. We will notify you with reasons for the
          denial. In the event that you desire to appeal a denial decision
          on your request, you may contact us with any of the contact
          methods indicated above.</span
        ></span
      ></span
    ></span
  ></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 10.5pt"
  ><span style="font-family: 等线">&nbsp;</span></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 10.5pt"
  ><span style="font-family: 等线"
    ><span style="font-size: 12pt"
      ><span style="font-family: 'Times New Roman', serif"
        ><span style="color: #505050"
          >Non-Discrimination Statement</span
        ></span
      ></span
    ></span
  ></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 10.5pt"
  ><span style="font-family: 等线">&nbsp;</span></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 10.5pt"
  ><span style="font-family: 等线"
    ><em
      ><span style="font-size: 12pt"
        ><span style="font-family: 'Times New Roman', serif"
          ><span style="color: #505050"
            >We will not discriminate against you for exercising your
            rights and choices under applicable state privacy laws,
            although some of the functionality and features available to
            you may change or no longer be available to you. Any
            difference in the services&nbsp;is&nbsp;related to the value
            provided.</span
          ></span
        ></span
      ></em
    ></span
  ></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 10.5pt"
  ><span style="font-family: 等线">&nbsp;</span></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 10.5pt"
  ><span style="font-family: 等线"
    ><span style="font-size: 12pt"
      ><span style="font-family: 'Times New Roman', serif"
        ><span style="color: #505050"
          >De-Identified Data Disclosure</span
        ></span
      ></span
    ></span
  ></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 10.5pt"
  ><span style="font-family: 等线">&nbsp;</span></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 10.5pt"
  ><span style="font-family: 等线"
    ><span style="font-size: 12pt"
      ><span style="font-family: 'Times New Roman', serif"
        ><span style="color: #505050"
          >We may use de-identified data in some instances. We either
          maintain such data without attempting to re-identify it or treat
          such data as personal data subject to applicable state privacy
          law.</span
        ></span
      ></span
    ></span
  ></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 10.5pt"
  ><span style="font-family: 等线">&nbsp;</span></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 10.5pt"
  ><span style="font-family: 等线"
    ><span style="font-size: 12pt"
      ><span style="font-family: 'Times New Roman', serif"
        ><span style="color: #505050"
          >CPA Profiling Disclosure</span
        ></span
      ></span
    ></span
  ></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 10.5pt"
  ><span style="font-family: 等线">&nbsp;</span></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 10.5pt"
  ><span style="font-family: 等线"
    ><span style="font-size: 12pt"
      ><span style="font-family: 'Times New Roman', serif"
        ><span style="color: #505050"
          >We do not engage in profiling of consumers in furtherance of
          automated decisions that produce legal or similarly significant
          effects, as those terms are defined under the CPA.</span
        ></span
      ></span
    ></span
  ></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 10.5pt"
  ><span style="font-family: 等线">&nbsp;</span></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 10.5pt"
  ><span style="font-family: 等线"
    ><span style="font-size: 12pt"
      ><span style="font-family: 'Times New Roman', serif"
        ><span style="color: #505050">Contact Information</span></span
      ></span
    ></span
  ></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 10.5pt"
  ><span style="font-family: 等线">&nbsp;</span></span
>
</p>

<p style="text-align: justify">
<span style="font-size: 10.5pt"
  ><span style="font-family: 等线"
    ><span style="font-size: 12pt"
      ><span style="font-family: 'Times New Roman', serif"
        ><span style="color: #505050"
          >If you have any questions about this Notice or need to access
          it in an alternative format due to having a disability, please
          contact&nbsp;</span
        ></span
      ></span
    ><a
      href="mailto:Legal.usa@hikvision.com"
      style="color: #007bff; text-decoration: none"
      ><span style="font-size: 12pt"
        ><span style="font-family: 'Times New Roman', serif"
          >Legal.usa@hikvision.com</span
        ></span
      ></a
    ><span style="font-size: 12pt"
      ><span style="font-family: 'Times New Roman', serif"
        ><span style="color: #505050"
          >&nbsp;or 1-866-200-6690 (Toll-Free).</span
        ></span
      ></span
    ></span
  ></span
>
</p>
`;
